var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHexagonShape(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.875 6.77008C20.2187 6.96554 20.5041 7.24905 20.7018 7.59143C20.8995 7.93382 21.0025 8.32271 21 8.71808V16.0021C21 16.8111 20.557 17.5571 19.842 17.9501L13.092 22.2201C12.7574 22.4038 12.3818 22.5001 12 22.5001C11.6182 22.5001 11.2426 22.4038 10.908 22.2201L4.158 17.9501C3.80817 17.7589 3.51612 17.4772 3.31241 17.1346C3.1087 16.7919 3.0008 16.4007 3 16.0021V8.71708C3 7.90808 3.443 7.16308 4.158 6.77008L10.908 2.79008C11.2525 2.60011 11.6396 2.50049 12.033 2.50049C12.4264 2.50049 12.8135 2.60011 13.158 2.79008L19.908 6.77008H19.875Z",
    fill: "#FFB894",
    stroke: "#FFB894",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHexagonShape);
export default __webpack_public_path__ + "static/media/hexagon-shape.38f7fa7c7fbbcad6579f95adc20a6dc4.svg";
export { ForwardRef as ReactComponent };